export default __webpack_public_path__ + "63e3d3e3f9a676e1b1e30e5a54e61d6a.svg";